import { STORE_EVENTS } from './events/store-events';
import { getErrorString, Logger } from 'bernie-logger';
import { ILocalization } from 'bernie-l10n';
import { MultiItemContext, PackageType } from 'models/multi-item/multi-item-types';

export enum CollectionBusinessModel {
  EC = 'EC', //Expedia Collect
  HC = 'HC' // Hotel Collect
}

export enum MultiItemStoreStatus {
  IDLE,
  ADDING_PROPERTY_SUCCESS,
  ADDING_PROPERTY_FAILURE,
  PREPARE_CHECKOUT_PROCESSING,
  PREPARE_CHECKOUT_SUCCESS,
  PREPARE_CHECKOUT_FAILURE,
  ADDING_PROPERTY,
  FETCHING,
  FETCH_FAILURE,
  FETCH_SUCCESS,
  REMOVE_PROPERTY_SUCCESS,
  REMOVE_PROPERTY_FAILURE,
  ADDING_PROPERTY_SUCCESS_CHECKOUT_NOW
}

export interface CartInfo {
  id: string;
  timestamp: number;
  type: CollectionBusinessModel;
}

export const SHOPPING_CART_KEY = 'curr_cart';
export const CART_EXPIRATION_IN_HOURS = 12;
export const INCOMPATIBLE_RATEPLAN = 'trying to add a rateplan with incompatible business model';

export function updateStatus(
  logger: Logger,
  setError: (error) => void,
  status: MultiItemStoreStatus,
  l10n: ILocalization,
  error?: string
): MultiItemStoreStatus {
  if (logger && typeof logger.logEvent === 'function') {
    switch (status) {
      case MultiItemStoreStatus.ADDING_PROPERTY_FAILURE:
        logger.logEvent(
          STORE_EVENTS.BEX_API_MULTI_ITEM_ADD_PROPERTY_ERROR,
          getErrorString(new Error(`Multi Item - Adding property failure, ${error}`))
        );
        setError({ message: l10n.formatText('user.errorSummary.default.heading') });
        break;
      case MultiItemStoreStatus.FETCH_FAILURE:
        logger.logEvent(STORE_EVENTS.BEX_API_MULTI_ITEM_FETCH_ERROR, getErrorString(new Error(`Multi Item - Fetch failure, ${error}`)));
        setError({ message: l10n.formatText('user.errorSummary.default.heading') });
        break;
      case MultiItemStoreStatus.PREPARE_CHECKOUT_FAILURE:
        logger.logEvent(
          STORE_EVENTS.BEX_API_MULTI_ITEM_CHECKOUT_PROPERTY_ERROR,
          getErrorString(new Error(`Multi Item - Prepare checkout failure, ${error}`))
        );
        setError({ message: l10n.formatText('user.errorSummary.default.heading') });
        break;
      case MultiItemStoreStatus.REMOVE_PROPERTY_FAILURE:
        logger.logEvent(
          STORE_EVENTS.BEX_API_MULTI_ITEM_REMOVE_PROPERTY_ERROR,
          getErrorString(new Error(`Multi Item - Remove property failure, ${error}`))
        );
        setError({ message: l10n.formatText('user.errorSummary.default.heading') });
        break;
      default:
        setError(null);
        break;
    }
  }

  return status;
}

export function buildMultiItemContext(query: any = {}): MultiItemContext {
  return !query.misId || !query.packageType
    ? undefined
    : {
        id: query.misId,
        packageType: PackageType[query.packageType.toString().toUpperCase()] as any
      };
}

export function isStoredUserCartExpired(cartInfo: CartInfo): boolean {
  if (!cartInfo) {
    return true;
  }

  const currentTimestamp = new Date().valueOf();
  const cartTimestamp = cartInfo.timestamp;
  const cartDate = new Date(cartTimestamp);
  const cartExpiryTimestamp = cartDate.setHours(cartDate.getHours() + CART_EXPIRATION_IN_HOURS);

  return currentTimestamp > cartExpiryTimestamp;
}

export function loadCartFromStorage(): CartInfo {
  let cartInfo = JSON.parse(localStorage.getItem(SHOPPING_CART_KEY));

  if (isStoredUserCartExpired(cartInfo)) {
    cartInfo = clearCartFromStorage();
  }

  return cartInfo;
}

export function clearCartFromStorage() {
  localStorage.removeItem(SHOPPING_CART_KEY);

  return null;
}

export function saveCartInStorage(cartInfo: CartInfo) {
  localStorage.setItem(SHOPPING_CART_KEY, JSON.stringify(cartInfo));
}
